import { type PropsWithChildren } from "react"
import { Container, GridItem } from "@octopus-energy/coral/atoms"

export function DashboardLayoutSelectArea({ children }: PropsWithChildren) {
    return (
        <GridItem
            gridArea="select"
            alignSelf="center"
        >
            <Container paddingX={{ base: "sm", md: "none" }}>{children}</Container>
        </GridItem>
    )
}
